module.exports = __webpack_public_path__ + "media/images/views/candidate/request/candidate-info-4110cfb17edaa0493e44fddafd8b0c81.png";